
// export function calculateScaleFactor(scene) {
//     let sceneW = scene.cameras.main.width;
//     let sceneH = scene.cameras.main.height;

//     let bg = scene.add.image(sceneW / 2, sceneH / 2, 'safeZone').setVisible(false);

//     let bgWidth = bg.width;
//     let bgHeight = bg.height;

//     let templateX = bg.x;
//     let templateY = bg.y;

//      const designWidth = 1920;
//      const designHeight = 1080;

//     let scaleFactor = sceneH / bgHeight;

//     if ((bgWidth * scaleFactor) < sceneW) {
//         scaleFactor = sceneW / bgWidth;
//     }

//     // Safe Zone Boundaries (position & size after scaling)
//     let safeZoneWidth = bgWidth * scaleFactor;
//     let safeZoneHeight = bgHeight * scaleFactor;
//     let safeZoneX = (sceneW - safeZoneWidth) / 2;
//     let safeZoneY = (sceneH - safeZoneHeight) / 2;
//     // Remove the temporary image to prevent rendering issues
//     bg.destroy();
//     //bg.setVisible(false);

//     return { scaleFactor, safeZoneX, safeZoneY, safeZoneWidth, safeZoneHeight, designHeight, designWidth, templateX, templateY};
// }

export function calculateScaleFactor(scene) {
    let sceneW = scene.cameras.main.width;
    let sceneH = scene.cameras.main.height;

    let bg = scene.add.image(sceneW / 2, sceneH / 2, 'safeZone').setVisible(false);

    let bgWidth = bg.width;
    let bgHeight = bg.height;

    let templateX = bg.x;
    let templateY = bg.y;

    const designWidth = 1920;
    const designHeight = 1080;

    // Calculate scale factor based on the aspect ratio that fits best
    let scaleX = sceneW / bgWidth;
    let scaleY = sceneH / bgHeight;
    
    // Use the smaller scale factor to ensure everything fits without cropping
    // This approach ensures all content is visible within the safe zone
    let scaleFactor = Math.min(scaleX, scaleY);
    
    // Alternative approach: Use the larger scale factor to fill the screen (might crop content)
    // Uncomment the line below if you want to fill the screen instead
    scaleFactor = Math.max(scaleX, scaleY);

    // Safe Zone Boundaries (position & size after scaling)
    let safeZoneWidth = bgWidth * scaleFactor;
    let safeZoneHeight = bgHeight * scaleFactor;
    let safeZoneX = (sceneW - safeZoneWidth) / 2;
    let safeZoneY = (sceneH - safeZoneHeight) / 2;
    
    // Remove the temporary image to prevent rendering issues
    bg.destroy();

    return { 
        scaleFactor, 
        safeZoneX, 
        safeZoneY, 
        safeZoneWidth, 
        safeZoneHeight, 
        designHeight, 
        designWidth, 
        templateX, 
        templateY,
        sceneW,
        sceneH
    };
}